import React, { useState, useEffect } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import Tooltip from "@mui/material/Tooltip";
import toast from "react-hot-toast";
import {
    getOrgKeyValue,
    getVendorDetailsByUUID,
    getVendorList,
    logVendorHistory,
} from "../../../services/index";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import Select from 'react-select';

const VendorView = (props) => {
    let { id } = useParams();
    let navigate = useNavigate();
    const [logData, setLogData] = useState({});
    const [rows, setRows] = useState([]);
    const [rows2, setRows2] = useState([]);
    const [vendorDetails, setVendorDetails] = useState([]);
    const [vendorAddressDetails, setVendorAddressDetails] = useState([]);
    const [vendorListDetails, setVendorListDetails] = useState(null);
    const [index, setIndex] = useState(0);
    const [filterText, setFilterText] = useState("");
    const [org, setOrg] = useState({ value: '' });
    const [orgOptions, setOrgOptions] = useState([]);
    const orgDetail = JSON.parse(localStorage.getItem('orgDetail'));

    const getAllVendorsRecords = () => {
        let Vendors_data = {
            page: index,
            size: 15,
            search: filterText,
            uuid: org?.value
        };
        getVendorList(Vendors_data).then((res) => {
            if (res.errorCode === 0) {
                if (index === 0) {
                    const d = res.responsePacket.data;
                    setRows(d);
                    setRows2(d);
                    if (d.length > 0) {
                        getVendorDetails(d[0].recordId);
                    }
                } else {
                    const setVendorsClone = [...rows, ...res.responsePacket.data];
                    setRows(setVendorsClone);
                    setRows2(setVendorsClone);
                }
                setIndex(index + 1);
                setVendorListDetails({
                    recordsFiltered: res.responsePacket.recordsFiltered,
                    recordsTotal: res.responsePacket.recordsTotal,
                    total: res.responsePacket.total,
                });
            } else {
                toast(res.message);
            }
        });
    };

    const getVendorDetails = (id) => {
        getVendorDetailsByUUID(id).then((res) => {
            if (res.errorCode === 0) {
                let d = res.responsePacket;
                setVendorDetails(d);
                d.addressList.map((a) => {
                    if (a.addressType === "Billing") {
                        d.billAdd = a;
                    }
                    if (a.addressType === "Shipping") {
                        d.shipAdd = a;
                    }
                });

                setVendorAddressDetails(res.responsePacket.addressList);
            } else {
                toast.error(res.message);
            }
        });
    };

    useEffect(() => {
        if (org.value) {
            getVendorDetails(id);
        }
    }, [id, org]);

    useEffect(() => {
        if (org.value !== "") {
            getAllVendorsRecords();
        }
    }, [filterText, org]);

    useEffect(() => {
        getOrgOptions();
    }, []);

    const getOrgOptions = () => {
        if (orgOptions) {
            getOrgKeyValue().then((res) => {
                if (res.errorCode === 0) {
                    const options = res.responsePacket?.map((d) => ({
                        value: d.key,
                        label: d.value,
                    }));
                    setOrg(options[0]);
                    setOrgOptions(options);
                } else {
                    toast(res.message);
                }
            });
        }
    }

    useEffect(() => {
        logVendorHistory(id).then((res) => {
            if (res.errorCode === 0) {
                const d = res.responsePacket;
                setLogData(d);
            } else {
                toast(res.message);
            }
        });
    }, [id]);

    let time;
    const handleSearch = (e) => {
        const { value } = e.target;
        clearTimeout(time);
        time = setTimeout(() => {
            setIndex(0);
            setFilterText(value);
        }, 500);
    };

    const handleFilter = (e) => {
        setIndex(0);
        setOrg(e);
    };

    return (
        <>
            <div
                className="list-column column d-print-none"
                style={{ width: "300px" }}
            >
                <div className="fill list-header topgrad d-print-none">
                    <div className="list-filter pt-3 d-flex align-items-center">
                        <div className="listFilterAndSearch">
                            <Link to="/vendors/new" className="newListBtn">
                                <AddIcon />
                            </Link>
                            {orgDetail?.isDefault && <div className="listFilter">
                                <Select value={org} options={orgOptions} onChange={handleFilter} />
                            </div>}
                            <div className="input-group paginationSearchInput listSearch">
                                <div className="input-group-prepend ">
                                    <span className="input-group-text" id="basic-addon1">
                                        <SearchRoundedIcon />
                                    </span>
                                </div>
                                <input
                                    autoComplete="off"
                                    className="form-control"
                                    type="text"
                                    placeholder="Search..."
                                    onChange={handleSearch}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="scroll-y fill body scrollbox list-body">
                    <div className="table-responsive overflow-initial">
                        <table
                            id="ember7912"
                            className="table zi-table table-hover ember-view header-fixed"
                        >
                            {rows &&
                                (rows.length > 0 ? (
                                    <tbody>
                                        {rows.map((row, index) => (
                                            <tr
                                                key={index}
                                                className={`listTr ${id === row.recordId ? "activeRecord" : ""
                                                    }`}
                                                onClick={() => getVendorDetails(row.recordId)}
                                            >
                                                <td>
                                                    <Link
                                                        to={`/vendors/${row.recordId}`}
                                                        className={`${id === row.recordId ? "text-primary" : "text-grey"
                                                            }`}
                                                    >
                                                        <span className="titleTr">{row.title}</span>
                                                        <span className="d-flex justify-content-between">
                                                            <span>Phone: {row?.phone}</span>
                                                        </span>
                                                    </Link>
                                                </td>
                                            </tr>
                                        ))}
                                        {vendorListDetails &&
                                            vendorListDetails.recordsTotal > rows.length && (
                                                <div className="pt-3">
                                                    <button
                                                        className="btn mx-auto newListBtn"
                                                        onClick={getAllVendorsRecords}
                                                    >
                                                        Load More
                                                    </button>
                                                </div>
                                            )}
                                    </tbody>
                                ) : (
                                    <div className="my-3 text-black text-center">
                                        No Data Available!
                                    </div>
                                ))}
                        </table>
                    </div>
                </div>
            </div>

            <div className="column content-column " style={{ left: "301px" }}>
                <div className="header no-border d-flex align-items-center p-4">
                    <a
                        className="over-flow header-title text-uppercase"
                        style={{ fontSize: "x-large" }}
                    >
                        &nbsp;
                    </a>
                    <div>
                        <div className="btn-toolbar align-items-center">
                            <div>
                                <button
                                    id="ember3047"
                                    className="btn btn-primary tooltip-container ember-view"
                                >
                                    <EditIcon
                                        style={{ fontSize: "15px", cursor: "pointer" }}
                                        onClick={() => {
                                            navigate("/vendors/" + vendorDetails.recordId + "/edit");
                                        }}
                                    />
                                </button>
                            </div>
                            <Tooltip title="Back to List">
                                <Link to={"/vendors"} className="p-0">
                                    <button
                                        id="ember3047"
                                        className="btn btn-primary tooltip-container ember-view"
                                    >
                                        <span className="d-flex align-items-center">Back</span>
                                    </button>
                                </Link>
                            </Tooltip>
                        </div>
                    </div>
                </div>
                <Tabs className="upperTabs">
                    <TabList>
                        <Tab>Primary Details</Tab>
                        <Tab>Log History</Tab>
                    </TabList>

                    <TabPanel className="p-3">
                        <div className="ember-view scroll-y noscroll-x fill body scrollbox">
                            <div className="customTable">
                                {vendorDetails && vendorDetails ? (
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td>Name:</td>
                                                <td>{vendorDetails.title}</td>
                                            </tr>
                                            <tr>
                                                <td>Phone:</td>
                                                <td>{vendorDetails.phone}</td>
                                            </tr>
                                            <tr>
                                                <td>Email:</td>
                                                <td>{vendorDetails.email}</td>
                                            </tr>
                                            <tr>
                                                <td>GST:</td>
                                                <td>{vendorDetails.gstNumber}</td>
                                            </tr>
                                            <tr>
                                                <td>FSSAI:</td>
                                                <td>{vendorDetails?.vendorFssai}</td>
                                            </tr>
                                            <tr>
                                                <td>PriceList:</td>
                                                <td>{vendorDetails.itemPriceListTitle}</td>
                                            </tr>
                                            <tr>
                                                <td>TDS:</td>
                                                <td>{vendorDetails.tdsTitle}</td>
                                            </tr>

                                            <tr>
                                                <td>Payment Term:</td>
                                                <td>{vendorDetails.paymentTermTitle}</td>
                                            </tr>
                                            <tr>
                                                <td>Billing Address:</td>
                                                <td>{vendorDetails.billAdd?.addressLine1}</td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td>{vendorDetails.billAdd?.addressLine2}</td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td>
                                                    {vendorDetails.billAdd?.city}&nbsp;
                                                    {vendorDetails.billAdd?.state}&nbsp;
                                                    {vendorDetails.billAdd?.pinCode}&nbsp;
                                                    {vendorDetails.billAdd?.country}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Shipping Address:</td>
                                                <td>{vendorDetails.shipAdd?.addressLine1}</td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td>{vendorDetails.shipAdd?.addressLine2}</td>
                                            </tr>
                                            <tr>
                                                {" "}
                                                <td></td>
                                                <td>
                                                    {vendorDetails.shipAdd?.city}&nbsp;
                                                    {vendorDetails.shipAdd?.state}&nbsp;
                                                    {vendorDetails.shipAdd?.pinCode}&nbsp;
                                                    {vendorDetails.shipAdd?.country}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                ) : (
                                    <></>
                                )}
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel className="p-3">
                        <table>
                            {logData.length === 0 ? (
                                "No Changes Found"
                            ) : (
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Changes</th>
                                    </tr>
                                </thead>
                            )}
                            {logData.length >= 1 && (
                                <tbody>
                                    {logData?.map((history, i) => {
                                        return (
                                            <tr key={i}>
                                                <td style={{ verticalAlign: "top", width: "80px" }}>
                                                    {history?.transactionDate?.substring(0, 10)}
                                                    :&nbsp;&nbsp; <br />
                                                    Time:
                                                    {history?.transactionDate
                                                        ?.split("T")[1]
                                                        ?.substring(0, 5)}
                                                </td>

                                                <td>
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: history?.message
                                                                .replaceAll("\n", "<br />")
                                                                .replaceAll("\t", "&nbsp;&nbsp;&nbsp;&nbsp;"),
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            )}
                        </table>
                    </TabPanel>
                </Tabs>
            </div>
        </>
    );
};

export default VendorView;
